import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"twitter\">\n<path d=\"M17.99 2H21.298L14.071 10.26L22.573 21.5H15.916L10.702 14.683L4.736 21.5H1.426L9.156 12.665L1 2H7.826L12.539 8.231L17.99 2ZM16.829 19.52H18.662L6.83 3.876H4.863L16.829 19.52Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol